import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Card, ImageAsset, ImageAssetFactory, ImageAssetType} from '../../domain/card';

@Component({
  selector: 'crds-address-my-location-form',
  templateUrl: './address-my-location-form.component.html'
})
export class AddressMyLocationFormComponent implements OnInit {

  @Input() form: FormGroup;
  @Input() card: Card<null>;
  images: ImageAsset[];
  imageAssetType = ImageAssetType;

  constructor(
    private imageAssetFactory: ImageAssetFactory) {
  }

  ngOnInit() {
    this.images = this.imageAssetFactory.create(this.card.image, this.form);
  }
}
